
export const setState = (key, value) => {
  try {
    const serializedState = JSON.stringify(value);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    return undefined;
  }
};

export const getState = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {}
};

export const STORAGE_KEYS = {
  HOT_SESSION_DATA: "hot_auth_session-data"
}